import { Translatable } from "@icc/shared/helpers";

export class DriveShaftLink {
    id: number | null;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}

